import type { Company, SpecialCompany } from '@/features/Companies/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type { CompanyQuestionApiResponse } from '@/features/CompanyQuestions/types';

export class CompaniesHttpService extends HttpService {
  loadCompanies(): HttpClientResponse<Company[]> {
    return this.httpClient.get('gesellschaften');
  }

  loadSpecialCompanies(): HttpClientResponse<SpecialCompany[]> {
    return this.httpClient.get('kassen/zusatzbeitraege');
  }

  loadQuestions(
    insuranceId: string,
  ): HttpClientResponse<CompanyQuestionApiResponse> {
    return this.httpClient.get(`gesellschaften/${insuranceId}/fragen`);
  }
}
